import baseDifference from "./component-library430.mjs";
import baseRest from "./component-library334.mjs";
import isArrayLikeObject from "./component-library391.mjs";
var without = baseRest(function(array, values) {
  return isArrayLikeObject(array) ? baseDifference(array, values) : [];
});
const without$1 = without;
export {
  without$1 as default
};
